/* Homepage-specific JS — loaded only on index template */

// Track homepage view
if (typeof ntrack === 'function') {
  ntrack('home_view', { page_type: 'homepage' });
}

// Authenticity video — click to play/pause
(function() {
  var wrap = document.querySelector('.sb-origin__video-wrap');
  if (!wrap) return;
  var video = wrap.querySelector('.sb-origin__video');
  if (!video) return;

  video.muted = true;

  function syncOriginState() {
    wrap.classList.toggle('is-playing', !video.paused);
  }

  function togglePlay() {
    if (video.paused) {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.then(syncOriginState).catch(function() {
          wrap.classList.remove('is-playing');
        });
      } else {
        syncOriginState();
      }
    } else {
      video.pause();
      syncOriginState();
    }
  }

  wrap.addEventListener('click', togglePlay);
  video.addEventListener('play', syncOriginState);
  video.addEventListener('pause', syncOriginState);
  syncOriginState();

  // Pause when out of viewport
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting && !video.paused) {
        video.pause();
        syncOriginState();
      }
    });
  }, { threshold: 0.2 });
  observer.observe(video);
})();

// Homepage UGC reel — play badge visibility + arrow navigation
(function() {
  var items = document.querySelectorAll('.sb-ugc__item');
  if (!items.length) return;

  items.forEach(function(item) {
    var video = item.querySelector('.sb-ugc__thumb');
    var playBadge = item.querySelector('.sb-ugc__play');
    if (!video || !playBadge) return;

    video.muted = true;

    function syncVideoState() {
      item.classList.toggle('sb-ugc__item--paused', video.paused);
      playBadge.classList.toggle('sb-ugc__play--hidden', !video.paused);
    }

    function toggleVideo() {
      if (video.paused) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise.then(syncVideoState).catch(function() {
            playBadge.classList.remove('sb-ugc__play--hidden');
          });
        } else {
          syncVideoState();
        }
      } else {
        video.pause();
        syncVideoState();
      }
    }

    item.addEventListener('click', toggleVideo);
    video.addEventListener('play', syncVideoState);
    video.addEventListener('playing', syncVideoState);
    video.addEventListener('pause', syncVideoState);
    video.addEventListener('loadeddata', syncVideoState);
    video.addEventListener('canplay', syncVideoState);

    // Initial sync after media state has had a chance to settle
    requestAnimationFrame(function() {
      syncVideoState();
    });
    setTimeout(syncVideoState, 150);
  });

  // Arrow navigation
  var scrollEl = document.querySelector('.sb-ugc__scroll');
  var leftBtn = document.querySelector('.sb-ugc__arrow--left');
  var rightBtn = document.querySelector('.sb-ugc__arrow--right');

  if (scrollEl && leftBtn && rightBtn) {
    var scrollAmount = 220; // item width + gap

    leftBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      scrollEl.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    rightBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      scrollEl.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    function updateArrows() {
      var atStart = scrollEl.scrollLeft <= 1;
      var atEnd = scrollEl.scrollLeft + scrollEl.clientWidth >= scrollEl.scrollWidth - 1;
      leftBtn.classList.toggle('sb-ugc__arrow--disabled', atStart);
      rightBtn.classList.toggle('sb-ugc__arrow--disabled', atEnd);
    }

    scrollEl.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  }
})();

// Homepage traceability phone mockup — simulate QR scan and reveal batch details
(function() {
  var trigger = document.querySelector('[data-trace-sim-trigger]');
  var panel = document.querySelector('[data-trace-panel]');
  var camera = document.querySelector('[data-trace-camera]');

  if (!trigger || !panel || !camera) return;

  var resetTimer = null;

  function resetSimulation() {
    panel.classList.remove('active');
    camera.classList.remove('is-scanned');
    trigger.removeAttribute('aria-pressed');
  }

  function runSimulation() {
    if (resetTimer) {
      clearTimeout(resetTimer);
      resetTimer = null;
    }

    trigger.setAttribute('aria-pressed', 'true');
    camera.classList.add('is-scanned');
    panel.classList.remove('active');

    window.setTimeout(function() {
      panel.classList.add('active');
      resetTimer = window.setTimeout(resetSimulation, 3800);
    }, 900);
  }

  trigger.addEventListener('click', runSimulation);
})();
